"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkDefaults = exports.useLinks = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var linkGenerators_1 = require("./linkGenerators");
var linkDefaults = {
    home: function () { return '/'; },
    profile: function () { return '/profile'; },
    profileEditEmail: function () { return '/profile/edit-email'; },
    profileEditPhone: function () { return '/profile/edit-phone'; },
    profileEditMarketing: function () { return '/profile/edit-marketing-details'; },
    plan: function () { return '/plan'; },
    moveOut: function () { return '/move-out'; },
    moveOutConfirm: function () { return '/move-out/confirm'; },
    renewal: function () { return '/renew'; },
    contactUs: function () { return '/contact-us'; },
    privacyPolicy: function () { return '/privacy'; },
    resetPassword: function () { return '/password-reset'; },
    billingHistory: function () { return '/billing-history'; },
    billingDetails: function (params) {
        return params && (params === null || params === void 0 ? void 0 : params.periodId) !== undefined && (params === null || params === void 0 ? void 0 : params.periodId) !== null
            ? "/billing-details/".concat(params.periodId)
            : "/billing-details";
    },
    openingMeterReads: function () { return '/meter-readings'; },
    quoteAndSwitch: function () { return '/'; },
    erroneousTransferHelp: function () { return '/'; },
    switchingMoveOut: function () { return '/'; },
    meterReads: function () { return '/meter-readings'; },
    meterReadsConfirmation: function () { return '/meter-readings/confirm'; },
    meterReadsNew: function (params) {
        return "/meter-readings/new/".concat(params && params.fuelType);
    },
    meterReadsNonCommHelp: function () { return '/'; },
    meterReadsHowToReadSmartMeters: function () { return '/'; },
    meterReadsHistory: function (params) {
        return params && params.fuelType
            ? "/meter-readings/history/".concat(params.fuelType)
            : '/meter-readings/history';
    },
    howBillingWorks: function () { return '/'; },
    helpNegativeCharge: function () { return '/'; },
    howIsInterestRewardCalculated: function () { return '/'; },
    howIsAnytimeChargingCreditCalculated: function () { return '/'; },
    understandingYourBalance: function () { return '/'; },
    usage: function (params) { return (0, linkGenerators_1.usageLinkWithParams)(params); },
    payments: function () { return '/payments'; },
    cardPayment: function () { return '/payments/make-card-payment'; },
    cardPaymentStatus: function () { return '/payments/make-card-payment/status'; },
    setupDirectDebit: function () { return '/payments/direct-debit/setup'; },
    directDebitCalculator: function () { return '/payments/direct-debit/calculator'; },
    setupDirectDebitConfirmation: function () { return '/payments/direct-debit/setup/confirm'; },
    applyForRefund: function () { return '/payments/refunds'; },
    refundPolicyHelp: function () { return '/refund-policy'; },
    refundConfirm: function () { return '/payments/refunds/confirm'; },
    refundNotEligible: function () { return '/payments/refunds/not-eligible'; },
    directDebitGuarantee: function () { return '/'; },
    goCardlessPrivacy: function () { return '/'; },
    downloadDirectDebitMandate: function () { return '/dd-mandate'; },
    updateDirectDebitDate: function () { return '/payments/direct-debit/change-date'; },
    updateDirectDebitDateConfirmation: function () {
        return '/payments/direct-debit/change-date/confirm';
    },
    updateDirectDebitAmount: function () { return '/payments/direct-debit/adjust-amount'; },
    updateDirectDebitAmountConfirmation: function () {
        return '/payments/direct-debit/adjust-amount/confirm';
    },
    usageEnergyUseHelp: function () { return '/usage-energy-help'; },
    billingStatementDownload: function (params) {
        return "/bal/bill/".concat(params && params.accountId, "?from=").concat(params && params.from, "&to=").concat(params && params.to);
    },
    migratedStatementDownload: function (params) {
        return "/bal/statements/account/".concat(params && params.accountId, "/statement/").concat(params && params.statementId);
    },
    debtAndEnergyHelp: function () { return "/debt-energy-help"; },
    helpCentre: function () { return '/'; },
    directDebitRequestServiceAgreement: function () { return '/'; },
    teleswitchInfo: function () { return '/'; },
};
exports.linkDefaults = linkDefaults;
function useLinks() {
    return (0, ui_tools_1.useLinks)();
}
exports.useLinks = useLinks;
